import React from "react";

// The SVGs exported from the Figma frames (progress/design_oko2-4204/assets),
// inlined so each keeps its exact path, stroke and size.

const CHEVRON_LEFT_PATH = "M15 18L9 12L15 6";
const CHEVRON_DOWN_PATH = "M4 6L8 10L12 6";
const CLOSE_PATH =
  "M7.1 18.3C6.7134 18.6866 6.0866 18.6866 5.7 18.3C5.3134 17.9134 5.3134 17.2866 5.7 16.9L9.89289 12.7071C10.2834 12.3166 10.2834 11.6834 9.89289 11.2929L5.7 7.1C5.3134 6.7134 5.3134 6.0866 5.7 5.7C6.0866 5.3134 6.7134 5.3134 7.1 5.7L11.2929 9.89289C11.6834 10.2834 12.3166 10.2834 12.7071 9.89289L16.9 5.7C17.2866 5.3134 17.9134 5.3134 18.3 5.7C18.6866 6.0866 18.6866 6.7134 18.3 7.1L14.1071 11.2929C13.7166 11.6834 13.7166 12.3166 14.1071 12.7071L18.3 16.9C18.6866 17.2866 18.6866 17.9134 18.3 18.3C17.9134 18.6866 17.2866 18.6866 16.9 18.3L12.7071 14.1071C12.3166 13.7166 11.6834 13.7166 11.2929 14.1071L7.1 18.3Z";

const Svg = ({ size, children, className }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    className={className}
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", flexShrink: 0 }}
  >
    {children}
  </svg>
);

const strokeProps = (stroke, width = 2) => ({
  stroke,
  strokeWidth: width,
  strokeLinecap: "round",
  strokeLinejoin: "round",
});

export const ChevronLeftIcon = ({ stroke, className }) => (
  <Svg size={24} className={className}>
    <path d={CHEVRON_LEFT_PATH} {...strokeProps(stroke)} />
  </Svg>
);

export const ChevronDownIcon = ({ stroke, className }) => (
  <Svg size={16} className={className}>
    <path d={CHEVRON_DOWN_PATH} {...strokeProps(stroke, 1.33333)} />
  </Svg>
);

export const CloseIcon = ({ fill }) => (
  <Svg size={24}>
    <path d={CLOSE_PATH} fill={fill} />
  </Svg>
);

export const PlusIcon = ({ stroke }) => (
  <Svg size={16}>
    <path d="M8 3.33333V12.6667" {...strokeProps(stroke)} />
    <path d="M3.33333 8H12.6667" {...strokeProps(stroke)} />
  </Svg>
);

export const MinusIcon = ({ stroke }) => (
  <Svg size={16}>
    <path d="M3.33333 8H12.6667" {...strokeProps(stroke)} />
  </Svg>
);

export const InfoIcon = ({ stroke }) => (
  <Svg size={24}>
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      {...strokeProps(stroke)}
    />
    <path d="M12 16V12" {...strokeProps(stroke)} />
    <path d="M12 8H12.01" {...strokeProps(stroke)} />
  </Svg>
);
